import React, { Fragment } from 'react';
import { Card, CardHeader, CardBody, Row, Modal, ModalHeader, ModalBody, Label, FormGroup, Form, Media, Input } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { useState, useEffect } from 'react';
import { deletePaymentMethod, showPaymentMethod, getPackages, getStatus, getPaymentStatus } from '../../../CommonURL';
import { Link, useNavigate } from 'react-router-dom';
import SweetAlert from 'sweetalert2';
import { Add } from '../../../Constant';
import { toast } from 'react-toastify';
import { Btn, H5, H3, Breadcrumbs } from '../../../AbstractElements';
import { getDataWithToken, postDataWithToken } from '../../../Utils/restUtils';
import SearchList from '../../../CommonElements/Search';
import { paymentColumns } from '../../../Data/Ecommerce/PaymentsTableList';
import Transparentspinner from '../../Common/loader/Transparentspinner';

const PaymentMethodList = () => {
    const [PackagesData, setPackagesData] = useState([]);
    const [packagesList, setPackagesList] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [tempSearch, setTempSearch] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)

    const style2 = { width: 60, fontSize: 13, padding: 3 };
    useEffect(() => {
        getPackagesData(); 
    }, []);

   const applyFilter = () => {
  if (!tempSearch) {
    setPackagesData(packagesList);
    return;
  }

  const keyword = tempSearch.toLowerCase();

  const filtered = packagesList.filter(item =>
    item.Name?.toLowerCase().includes(keyword) ||
    item.Type?.toLowerCase().includes(keyword) ||
    item.account_name?.toLowerCase().includes(keyword)
  );

  setPackagesData(filtered);
};


   const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };


    const handleSwitchToggle = async (event, itemId) => {
        const checked = event.target.checked;
        let reqSwitch = null;
        if (checked === true) {
            reqSwitch = { payment_method_id: itemId, status: 'inactive' }
        } else {
            reqSwitch = { payment_method_id: itemId, status: 'active' }
        }
        const statusChange = await postDataWithToken(getPaymentStatus, reqSwitch);
        if (statusChange.data.status === true) {
            toast.success(statusChange.data.message);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
    }

    const deletePackagesList = (id) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this imaginary file!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'cancel',
            reverseButtons: true
        }).then(async (result) => {
            setLoading(true);
            if (result.value) {
                const deleteRes = { payment_method_id: id }
                const packageRemove = await postDataWithToken(deletePaymentMethod, deleteRes);
                if (packageRemove.data.status === true) {
                    SweetAlert.fire(
                        'Deleted!',
                        'Your file has been deleted.',
                        'success'
                    );
                    getPackagesData();
                } else {
                    navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
                }
            } else {

            }
            setLoading(false);
        });
    };

    const redirectToEditForm = (data) => {
        const editFormURL = `${process.env.PUBLIC_URL}/configuration/payment-method-edit?id=${data.id}`;
        navigate(editFormURL);
    };

       const getPackagesData = async () => {
  setLoading(true);
  const res = await getDataWithToken(showPaymentMethod);

  const mappedData = res.data.map((e, index) => ({
    Si: index + 1,
    Name: e.name,
    Type: e.type,
    account_name: e.account_name,
    Status: (
      <Media body className="flex-grow-1 text-end icon-state">
        <Label className="switch">
          <Input
            type="checkbox"
            defaultChecked={e.status === "active"}
            onChange={(event) => handleSwitchToggle(event, e.id)}
          />
          <span className="switch-state"></span>
        </Label>
      </Media>
    ),
    action: (
      <div>
        <Btn
          attrBtn={{
            style: style2,
            className: 'me-2',
            color: 'primary btn-xs',
            onClick: () => redirectToEditForm(e)
          }}
        >
          Edit
        </Btn>
        <Btn
          attrBtn={{
            style: style2,
            color: 'danger btn-xs',
            onClick: () => deletePackagesList(e.id)
          }}
        >
          Delete
        </Btn>
      </div>
    )
  }));

  setPackagesList(mappedData);   
  setPackagesData(mappedData);   
  setLoading(false);
};

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle='Payment Method' parent="Configuration" title="Payment" />
            <Card>
                <CardHeader><H3>Payment  method List</H3></CardHeader>
                <div style={{ paddingLeft: '22px', marginRight: '22px', marginBottom: '-10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', float: 'left' }}>
                     <SearchList updateSearchKeyword={updateSearchKeyword}  onEnter={applyFilter} />
                    <button className="btn btn-primary  mb-2 ms-2  " onClick={(applyFilter)}>Filter</button>
                  </div>
                    <div style={{ float: 'right' }}>
                        <Link to={`${process.env.PUBLIC_URL}/configuration/payment-method-add`} className="btn btn-primary">{Add}</Link>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            pagination
                            columns={paymentColumns}
                            data={PackagesData}
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default PaymentMethodList;